import styled from 'styled-components';

export const Image = styled.div`
  display: flex;
  width: 200px;
  height: 65px;
  min-height: 1vh;
  background-image: url(${({ imageSrc }) => imageSrc});
  background-size: 100% 100%;
  /*background-size: 75% 75%;*/
  opacity: 1;
  background-repeat: no-repeat;
  /*background-position: -15px center;*/
  background-position: left center;
  background-origin: border-box;

@media screen and (max-width: 992px) {
    width: 155px;
    height: 45px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  /*min-height: 130px;*/
  height: 15vh;
  background-color: ${({ bgColor }) => bgColor};

  @media screen and (max-width: 992px) {
    min-height: 14vh;
  }
`;

export const MarginBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: 0 auto;
`;

export const MarginBoxHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: 0 auto;

  @media screen and (max-width: 1185px) {
    width: 93%;
  }

  @media screen and (max-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const DropDownContent = styled.div`
  display: flex;
  justify-content: flex-end;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LinksContent = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const Anchor = styled.p`
  text-decoration: none;
  font-weight: 600;
  margin: 0 18px;

  @media screen and (max-width: 1264px) {
    font-size: 12px;
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  justify-content: space-evenly;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const BurgerBox = styled.div`
  display: flex;
`;
